export default __webpack_public_path__ + "static/media/home-mini.d6f921a3.svg";